module.exports = {
	"Search the video": "ابحث في الفيديو",
	"Explore": "استكشاف",
	"Print": "طباعة",
	"Download": "تحميل",
	"Share": "مشاركة",
	"Settings": "إعدادات",
	"Language": "اللغة",
	"Interface Language": "لغة الواجهة",
	"Transcript / Captions Language": "لغة النص المكتوب",
	"Transcript Language": "لغة النسخ",
	"Captions Language": "لغة النص المكتوب",
	"Show Transcript": "إظهار النص المنسوخ",
	"Show Captions": "إظهار النص المكتوب",
	"Show Heatmap": "إظهار الخريطة الحرارية",
	"Show Speakers in Transcript": "إظهار اسم المتحدث في النص المكتوب",
	"Keyword": "كلمة مفتاحية",
	"Keywords": "كلمة مفتاحية",
	"Topic": "الموضوع",
	"Topics": "الموضوعات",
	"Speaker": "المتحدث",
	"Speakers": "المتحدثين",
	"Transcript": "النسخ",
	"Previous": "السابق",
	"Next": "التالي",
	"Clear": "إزالة",
	"No results found": "لم يتم العثور على نتائج. حاول مرة أخرى أو استكشف.",
	"try another search or explore": "تجربة عملية بحث أو استكشاف أخرى",
	"Share Search": "شارك نتيجة البحث",
	"Share Time": "شارك التوقيت",
	"There is no transcript available in the selected language.": "لا يوجد نص مكتوب متاح من اللغة المختارة.",
	"Show {{count}} more": "عرض {{count}} إضافية",
	"Show {{count}} more_plural": "عرض {{count}} إضافية"
};


//////////////////
// WEBPACK FOOTER
// ./locale/ar.json
// module id = ./locale/ar.json
// module chunks = 0 1